import React from 'react'

function Footer() {
  return (
    <div className=' mt-5'>
      <p>Designed & Developed with ♥ BY<a className='text-blue-500' href='https://www.linkedin.com/in/piyush-yadav9343/' target='_blank' >  PIYUSH & AJAY</a> </p>
    </div>
  )
}

export default Footer
